import React from 'react';
import {
  PHARMACY_DRUG_INFO_DISCLAIMER,
  pharmacyDrugGroupLabel,
  pharmacyDrugIsPrescription,
} from '../constants/pharmacyCommonDrugs';
import { productUnitLabel } from '../constants/productUnits';
import './PharmacyDrugInfoPanel.css';

/** @param {{ drug: import('../constants/pharmacyCommonDrugs').PharmacyCommonDrug | null, category?: string, unit?: string }} props */
export default function PharmacyDrugInfoPanel({ drug, category, unit }) {
  if (!drug) return null;

  const rx = pharmacyDrugIsPrescription(drug);
  const displayCategory = category || drug.category;
  const displayUnit = unit || drug.unit;

  return (
    <aside className="pharm-drug-info" aria-label="Medicine information">
      <h4 className="pharm-drug-info-title">{drug.name}</h4>
      <dl className="pharm-drug-info-grid">
        <div>
          <dt>Active ingredient</dt>
          <dd>{drug.ingredient}</dd>
        </div>
        <div>
          <dt>Therapeutic group</dt>
          <dd>{pharmacyDrugGroupLabel(drug)}</dd>
        </div>
        <div>
          <dt>Common uses</dt>
          <dd>{drug.uses}</dd>
        </div>
        <div>
          <dt>Route / how to take</dt>
          <dd>{drug.route}</dd>
        </div>
        <div>
          <dt>Stock category</dt>
          <dd>{displayCategory}</dd>
        </div>
        <div>
          <dt>Stock unit</dt>
          <dd>{productUnitLabel(displayUnit)}</dd>
        </div>
        <div>
          <dt>Sale type</dt>
          <dd>{rx ? 'Prescription (Rx)' : 'May be sold OTC (check local rules)'}</dd>
        </div>
        {drug.caution ? (
          <div className="pharm-drug-info-row--full">
            <dt>Caution</dt>
            <dd>{drug.caution}</dd>
          </div>
        ) : null}
      </dl>
      <p className="pharm-drug-info-disclaimer">{PHARMACY_DRUG_INFO_DISCLAIMER}</p>
    </aside>
  );
}
